// extracted by mini-css-extract-plugin
module.exports = {"link":"_3sib94Eiy5TIInBbCfV9Yf"};